import React, { useState } from 'react';
import ForgotPassword from './ForgotPassword';
import OtpVerification from './OtpVerification';

const ForgotPasswordPage = () => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        email: "",
        newPassword: "",
    });

    return (
        <>
            {step === 1 ? (
                <ForgotPassword setStep={setStep} step={1} setFormData={setFormData}/>
            ) : (
                <OtpVerification formData={formData} />
            )}
        </>
    );
};

export default ForgotPasswordPage;
